/**
 * Liffner Collection Image Swiper v5.2
 * gap:0 on lines so inactive segments merge into one continuous line
 */
(function LiffnerSwiper() {
  'use strict';

  var SWIPE_THRESHOLD = 40;
  var MAX_IMAGES = 6;

  var IMG_POS_CSS = [
    'position:absolute','right:0','left:0','top:50%',
    'bottom:auto','margin:auto','max-width:100%','max-height:100%',
    'width:auto','transform:translateY(-50%)','display:block'
  ].join(';');

  var STYLES = [
    '.product-grid-image.lsw-on { overflow:hidden; }',
    '.lsw-on img { opacity:0 !important; pointer-events:none !important; transition:opacity 0.3s ease !important; }',
    '.lsw-on img.lsw-active { opacity:1 !important; pointer-events:auto !important; }',
    '.lsw-on img.hover_img { display:block !important; }',

    /* Line indicator — gap:0 so inactive segments merge into one line */
    '.lsw-lines {',
    '  position:absolute; bottom:0; left:0; right:0;',
    '  display:flex; gap:0;',
    '  pointer-events:none; z-index:5;',
    '}',
    '.lsw-line {',
    '  flex:1; height:2px;',
    '  background:rgba(0,0,0,0.15);',
    '  transition:background 0.25s ease;',
    '}',
    '.lsw-line.is-active { background:rgba(0,0,0,0.65); }',
    '@media (hover:hover) and (pointer:fine) { .lsw-lines { display:none; } }',
    '@media (prefers-reduced-motion:reduce) { .lsw-on img { transition:none !important; } }',
  ].join('\n');

  function injectStyles() {
    if (document.getElementById('lsw-styles')) return;
    var el = document.createElement('style');
    el.id = 'lsw-styles'; el.textContent = STYLES;
    document.head.appendChild(el);
  }

  function resizeImg(url, w) { return url.replace(/(\.[^.?]+)(\?|$)/, '_' + w + 'x$1$2'); }

  function fetchImages(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) { return d ? d.images : null; })
      .catch(function() { return null; });
  }

  function getHandle(container) {
    var el = container.parentElement;
    while (el) {
      if (el.tagName === 'A') {
        var m = (el.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      }
      el = el.parentElement;
    }
    return null;
  }

  function buildSlider(container, extraUrls) {
    var img1 = container.querySelector('img:not(.hover_img)');
    var img2 = container.querySelector('img.hover_img');
    if (!img1) return;

    container.classList.add('lsw-on');

    var slides = [img1];
    if (img2) {
      if (img2.dataset.src && !img2.src) { img2.src = img2.dataset.src; img2.removeAttribute('data-src'); }
      slides.push(img2);
    }
    if (extraUrls) {
      for (var i = 2; i < extraUrls.length && slides.length < MAX_IMAGES; i++) {
        var img = document.createElement('img');
        img.src = resizeImg(extraUrls[i], 600);
        img.alt = img1.alt || '';
        img.setAttribute('style', IMG_POS_CSS);
        container.appendChild(img);
        slides.push(img);
      }
    }
    if (slides.length < 2) { container.classList.remove('lsw-on'); return; }

    var linesEl = document.createElement('div');
    linesEl.className = 'lsw-lines';
    var lineEls = slides.map(function() {
      var l = document.createElement('div');
      l.className = 'lsw-line';
      linesEl.appendChild(l);
      return l;
    });
    container.appendChild(linesEl);

    var current = 0;

    function goTo(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i) { s.classList.toggle('lsw-active', i === idx); });
      lineEls.forEach(function(l, i) { l.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    goTo(0);

    container.addEventListener('mouseenter', function() { goTo(1); });
    container.addEventListener('mouseleave', function() { goTo(0); });

    var startX = 0, startY = 0, moved = false;
    container.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; moved = false;
    }, { passive: true });
    container.addEventListener('touchmove', function(e) {
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) + 5) { e.preventDefault(); moved = true; }
    }, { passive: false });
    container.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
    container.addEventListener('click', function(e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    container.dataset.lswBuilt = '1';
  }

  function processCard(container) {
    var handle = getHandle(container);
    if (!handle) { buildSlider(container, null); return; }
    fetchImages(handle).then(function(urls) { buildSlider(container, urls); });
  }

  function init() {
    var path = window.location.pathname;
    if (path.indexOf('/collections/') === -1 && path.indexOf('/search') === -1) return;
    injectStyles();
    var cards = document.querySelectorAll('.product-grid-image:not([data-lsw-built])');
    if (!cards.length) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { io.unobserve(entry.target); processCard(entry.target); }
      });
    }, { rootMargin: '300px' });
    cards.forEach(function(c) { io.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

})();
